import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BdbBackdropComponent } from '../bdb-backdrop/bdb-backdrop.component';

@Component({
  selector: 'app-bdb-dialogo',
  templateUrl: './bdb-dialogo.component.html',
  styleUrls: ['./bdb-dialogo.component.scss']
})
export class BdbDialogoComponent {

  @Input() idEl = 'bdb-at-dialogo';
  @Input() title = 'Inestabilidad de conexión';
  @Input() subtitle = 'Estamos experimentando inestabilidad en la conexión. Por favor, espera mientras intentamos reconectarte.';
  @Input() timeClosed = 20;
  @Input() closeWithTime = false;
  @Output() dialogueClosed = new EventEmitter<boolean>();
  @Output() dialoguefinishedTimer = new EventEmitter<boolean>();

  @ViewChild('bdbBackDrop') bdbBackdrop: BdbBackdropComponent;

  timerId: any;

  constructor() { }

  openDialogue(): void {
    this.bdbBackdrop.openBackdrop();
    if(this.closeWithTime){
      this.setTimeClosed();
    }
  }

  closeDialogue(): void {
    this.bdbBackdrop.closeBackdrop();
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
    this.dialogueClosed.emit(true);
  }

  setTimeClosed(): void {
    this.timerId = setTimeout(() => {
      this.closeDialogue();
      this.dialoguefinishedTimer.emit(true);
    }, this.timeClosed * 1000);
  }
}



// WEBPACK FOOTER //
// ./src/webcomponents/bdb-dialogo/bdb-dialogo.component.ts